import { createContext, useContext } from 'react'

import { AchievementsContextValue } from './achievements-context-types'

const AchievementsContext = createContext<AchievementsContextValue | null>(null)

/**
 * Reads the achievements context. Throws if used outside the provider.
 *
 * @returns {AchievementsContextValue}
 */
const useAchievements = (): AchievementsContextValue => {
  const context = useContext(AchievementsContext)

  if (context === null) {
    throw new Error(
      'useAchievements must be used within an AchievementsProvider',
    )
  }

  return context
}

export { AchievementsContext, useAchievements }
